import { Table } from 'dexie'
import { BaseEntityInterface, Settings } from '@email-editor/ui'
import { DataFileInterface } from '@systemeio/file-manager'

export interface EmailsInterface {
  id?: number
  systeme_email_id: number
  entities: BaseEntityInterface[]
  files: DataFileInterface[]
  settings: Settings
}

export type EmailsTableType = {
  emails: Table<EmailsInterface>
}

export const emailsSchema = {
  emails: '++id, systeme_email_id, entities, files, settings',
}
